import PoleItem from '@/utils/pole-item';

/**
 * 代表電柱
 */
export class MainPole extends PoleItem {
  /**
   * コンストラクタ
   */
  constructor(props) {
    super(props);
  }

  /**
   * ファクトリー
   */
  static of(orderInfo) {
    if (!orderInfo) {
      return null;
    }
    return new MainPole({
      areaCode:  orderInfo.kojiAreaCode,
      areaName:  orderInfo.kojiAreaName,
      lineCode:  orderInfo.kojiLineCode,
      lineName:  orderInfo.kojiLineName,
      poleNo:    orderInfo.kojiPoleNo,
      poleKind:  orderInfo.kojiPoleKind,
      latitude:  orderInfo.kojiLatitude,
      longitude: orderInfo.kojiLongitude,
    });
  }
}

// デフォルトエクスポート
export default MainPole;
